import { ChartDatasetClicks } from '@interfaces/mediakit.interface'
import React from 'react'
import './chart-horizontal-bar.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  dataset: ChartDatasetClicks
  name?: string
}

export default ({ dataset = null, name = '' }: Props) => {
  const calcWidth = (percentage: number) => {
    return { width: `${percentage}%` }
  }

  const setLabelDate = (label: string) => {
    const initialDate = new Date(label?.split(' - ')[0])
    const day = initialDate?.getDate() < 10 ? `0${initialDate?.getDate()}` : `${initialDate?.getDate()}`
    return `${day}/${initialDate?.getMonth() + 1}`
  }

  return (
    <div>
      {Array.apply(0, Array(dataset?.labels?.length))?.map((x: any, i: string | number) => (
        <div key={`${name}-graph-bar-${i}`}>
          <div className="line">
            <p title={setLabelDate(dataset?.labels[i])} className="pr-3">
              <strong>{setLabelDate(dataset?.labels[i])}</strong>
            </p>
            <div className="line-bar" title={dataset?.datasets[0]?.data[i]}>
              <span style={calcWidth(dataset?.datasets[0]?.data[i])} className="line-bar-line"></span>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
